import type { TextColor } from "@homeinstead/schemas";

/**
 * Same mapping as RichText `textColor` in @homeinstead/ui (richTextVariants).
 * Lets inquiry form copy follow the block’s CMS `textColor`.
 */
const INQUIRY_TEXT_CLASS: Record<NonNullable<TextColor>, string> = {
  "new-beginnings": "text-new-beginnings-base",
  support: "text-support-base",
  white: "text-white",
};

function inquiryTextColorClass(textColor?: TextColor) {
  return textColor
    ? INQUIRY_TEXT_CLASS[textColor]
    : INQUIRY_TEXT_CLASS["new-beginnings"];
}

/**
 * Field errors on inquiry forms often sit on a new-beginnings (green) section.
 * `text-error` reads as a harsh red/green clash, so we use colors that stay
 * on-brand and legible.
 */
function inquiryFormErrorTextClass(textColor?: TextColor) {
  switch (textColor) {
    case "white":
      return "text-error-light";
    case "support":
      return "text-white font-medium";
    default:
      return "text-support-base";
  }
}

export { inquiryFormErrorTextClass, inquiryTextColorClass };
